// removed by extract-text-webpack-plugin
module.exports = {"toast":"_34XdRNSEbsUikiFOHcbLzo","container":"_3B_ytrt1inIk7IPNIiF5Om","header":"_3J6rsipK36wB1Wmi8QBDwM","heading":"_37LVjJXuF-XfDK2bfcWae1","close-button":"fW8jU1my0waRUYj76z8l7","main-content":"_3OGkYOhsgGhNr-EQWXJ68W","icon":"EwQpYk4PTctGnNKqUKBWG","message":"_3bIXVn-CadQ1RPJA9afk81","action-buttons":"HHRDUnRVmvngzvRJmSgB7","shown":"_3f6ygO1Dsw262zEippxlxk","success":"NSZjRnRLOfG5MXeL8ajYw","info":"_4_ZyU2ded1T-8SD_0HFib","warning":"_1xOzyws_sgrcgyQevkf1RJ","error":"_1GhZGTRCPBNC0cSxqi5Tb5","spin":"vrVfBZXTD2xf7mQW0O8GP"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Toast/styles.scss
// module id = 922
// module chunks = 18